// Незаметный футер сборки виджета: git-хэш · время сборки.
// Значения зашиты на момент vite build через define (см. _shared/buildDefine.ts).
// Нужен, чтобы понимать, когда собраны виджеты (хэш совпадает с GitLab).
// Версию из version.json НЕ используем: на проде он недоступен на этапе сборки.
declare const __BUILD_COMMIT__: string;
declare const __BUILD_TIME__: string;

export function BuildInfo() {
    const commit  = typeof __BUILD_COMMIT__ !== 'undefined' ? __BUILD_COMMIT__ : '';
    const builtAt = typeof __BUILD_TIME__   !== 'undefined' ? __BUILD_TIME__   : '';
    if (!commit && !builtAt) return null;
    return (
        <div
            title={`Сборка виджета: коммит ${commit}, ${builtAt}`}
            style={{
                textAlign: 'center',
                fontSize: 11,
                lineHeight: 1.4,
                color: '#c7ccd4',
                padding: '10px 0 6px',
                userSelect: 'text',
            }}
        >
            {commit}{builtAt ? ` · ${builtAt}` : ''}
        </div>
    );
}
